export const environment = {
    production: false,
    api_url: "https://8yv5r13nd6.execute-api.ca-central-1.amazonaws.com",
    socket_url: "http://localhost:8000/",
};
